import produce from 'immer'
import { get, set } from 'lodash-es'
import { useCallback, useState } from 'react'

type ViewType = {
  showRankInPresentation: any
  fullScreen: boolean
  isRolling: boolean
  gd_pre_auto_play_speed: number
}

const getStoredAutoPlaySpeed = () => {
  if (typeof window === 'undefined') return 1

  return +(window.localStorage.getItem('gd_pre_auto_play_speed') || '') || 1
}

const getDefaultState = (): ViewType => ({
  showRankInPresentation: undefined,
  isRolling: false,
  fullScreen: true,
  gd_pre_auto_play_speed: getStoredAutoPlaySpeed(),
})

const ViewModel = () => {
  const [view, viewReplace] = useState<ViewType>(getDefaultState)
  const viewSet = useCallback(
    (path: string, value: ValueOrFunc) => viewReplace(produce<ViewType>((draft) => set(draft, path, typeof value === 'function' ? value(get(draft, path)) : value))),
    []
  )
  return { view, viewReplace, viewSet }
}

export default ViewModel
